export default "__VITE_ASSET__BqJRTgCV__"